export interface Register {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
  isAgree: boolean;
}


export interface VerifyEmailForm {
  email: string;
  otp?: string;
}

export interface LoginResponse {
  accessToken: string;
  accessTokenExpiryTs: number;
  refreshToken: string;
}
export interface UserLogin {
  email: string;
  password: string;
}

// Admin Module Types
export interface Admin {
  _id: string;
  name: string;
  email: string;
  is_active: boolean;
  is_super_admin: boolean;
  last_active: string | null;
  created_at: string;
}

export interface AdminListResponse {
  records: Array<{
    id: string;
    name: string;
    email: string;
    is_active: boolean;
    last_active: string | null;
    created_at: string;
    password_reset_requested: boolean;
  }>;
  total: number;
  page: number;
  limit: number;
}

export interface AdminStats {
  total: number;
  active: number;
  inactive: number;
  superAdmins: number;
}

// Removed - these endpoints don't exist in backend

// Removed - no endpoint to update admin profile in backend

export interface CreateAdminRequest {
  email: string;
  password: string;
  name?: string;
}

export interface UpdateAdminRequest {
  name?: string;
  email?: string;
}

export interface ChangePasswordRequest {
  password: string;
}

export interface AdminListParams {
  page?: number;
  limit?: number;
  search_query?: string;
  status?: "active" | "inactive";
}

// User Management Types (Admin endpoints)
export interface UserListItem {
  id: string;
  name: string;
  email: string;
  is_active: boolean;
  is_verified: boolean;
  is_2fa_enabled: boolean;
  image_url: string | null;
  created_at: string;
}

export interface UserListResponse {
  records: UserListItem[];
  total: number;
  page: number;
  limit: number;
}

export interface UserListParams {
  page?: number;
  limit?: number;
  search_query?: string;
  status?: "active" | "inactive";
}

export interface UserManagementStats {
  total: number;
  active: number;
  inactive: number;
  verified: number;
  unverified: number;
}

export interface User {
  fullname: string;
  image: string;
  email: string;
  username: string;
  phone: string;
  bankName: string;
  accountNumber: string;
  accountName: string;
  isAdmin: boolean;
  isVerified: boolean;
  isActive: boolean;
  isDeleted: boolean;
  isSuperAdmin: boolean;
  createdAt: string;
  updatedAt: string;
  id: string;
  role: "User" | "Admin";
}

export interface UpdateUserInfo {
  tronWalletAddress?: string;
  evmWalletAddress?: string;
  title?: string;
  profilePictureURL?: string;
  languages?: [
    {
      language: string;
      level: string;
    },
  ];
  skills?: [string];
  introduction?: string;
  isOnboarded?: boolean;
  education?: {
    school: string;
    startDate: Date | null;
    endDate: Date | null;
    industry: string;
    degree: string;
    description: string;
  };
  certificate?: {
    name: string;
    issueDate: Date | null;
    expiryDate: Date | null;
    codeId: string;
  };
}

export interface UpdateUserPassword {
  password: string;
}

export interface UpdateUserEmail {
  name?: string;
  email?: string;
}


export interface GetOtpForm {
  email: string;
}

export interface UserStats {
  totalUsers: number;
  activeUsers: number;
  newUsers: number;
  withdrawsFiat: number;
}


export enum TRANSACTIONENUM {
  SWAP = "Swap",
  SWAP_CRYPTO = "Swap Crypto",
  WITHDRAW = "Withdraw",
  WITHDRAW_FIAT = "Withdraw Fiat",
  WITHDRAW_CASH = "Withdraw Cash",
  MOBILE_MONEY = "Mobile Money",
}

export enum TRANSACTION_TYPE {
  DEPOSIT = 'Deposit',
  WITHDRAW = 'Withdraw',
  BUY = 'Buy',
  SELL = 'Sell',
  SWAP = 'Swap',
  NFT_TRANSFER = 'NFT_TRANSFER',
  NFT_RECEIVED = 'NFT_RECEIVED',
}

// Transaction Statistics Response (from /admin/transactions-stats/:type)
export interface TransactionStatsResponse {
  totalTransactions: number;
  totalVolume: number;
  successRate: number;
  recent24h: number;
}

// Transaction Response (from /admin/transactions-list)
export interface UserTransaction {
  id: string;
  _id: number;
  userId: string;
  walletId: string;
  fromAddress: string;
  toAddress: string;
  coinId: string;
  type: string; // "Deposit", "Withdraw", "Buy", "Sell", or "Swap"
  amount: number;
  amountInUsd: number;
  trxHash: string;
  status: string; // "completed", "pending", "rejected", or "in-progress"
  createdAt: string;
  user: {
    id: string;
    fullname: string;
    email: string;
    profilePicture: string;
  };
  coin: {
    id: string;
    name: string;
    symbol: string;
    icon: string;
    network: {
      id: string;
      name: string;
      symbol: string;
    };
  };
}

// Transactions List Response with Pagination
export interface TransactionsListResponse {
  data: UserTransaction[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

// Legacy TransactionStats interface for backward compatibility (deprecated)
export interface TransactionStats {
  totalTransactions: number;
  totalVolume: number;
  byType?: {
    [key in TRANSACTION_TYPE]: {
      count: number;
      volume: number;
      averageAmount: number;
    };
  };
  recentTransactions: number;
  successRate: number;
  topUsers?: Array<{
    userId: string;
    userEmail: string;
    transactionCount: number;
    totalVolume: number;
  }>;
}

export interface ListedUser {
  fullname: string;
  image: string;
  email: string;
  username: string;
  phone: string;
  bankName: string;
  accountNumber: string;
  accountName: string;
  isAdmin: false;
  isSuperAdmin: false;
  isVerified: true;
  isActive: true;
  isDeleted: false;
  createdAt: string;
  updatedAt: string;
  blackList: string;
  isBlocked: boolean;
  id: string;
  role: "User" | "Admin";
  userTransactionLimit: transction;
}

interface transction {
  swapUpperLimit: 20;
  swapLowerLimit: 20;
  withdrawUpperLimit: 20;
  withdrawLowerLimit: 40;
  blackList: true;
  createdAt: string;
  updatedAt: string;
  id: string;
}

export interface UserWalletDetail {
  wallet: {
    userId: string;
    evmAddress: string;
    evmKey: string;
    tronAddress: string;
    tronKey: string;
    btcAddress: string;
    btcKey: string;
    currentSwappedBalance: number;
    totalWithdrawnAmount: number;
    createdAt: string;
    updatedAt: string;
    id: string;
    totalBalanceInLocalCurrency: number;
    totalBalanceInUsd: number;
    localCurrency: any;
    usdCurrency: any;
    accountName: string;
    accountNumber: string;
    bankName: string;
  };
  balance: Array<{
    coinId: string;
    address: string;
    balance: number;
    networkId: string;
    id: string;
    name: string;
    symbol: string;
    logoUrl: string;
    networkName: string;
    networkSymbol: string;
    networkLogoUrl: string;
    price: number;
    balanceNaira: number;
  }>;
}

// User Wallet Management Types (Admin endpoints)
export interface UserWallet {
  _id: string;
  name: string;
  user_id: string;
  is_selected: boolean;
  created_at: string;
  updated_at: string;
}

export interface UserWalletListResponse {
  data: UserWallet[];
  message: string;
  status: number;
}

export interface WalletBalance {
  userId: string;
  walletId: string;
  balance: string;
  balanceInFiat: number;
  balanceInUsd: number;
  coinId: string;
  currentPrice: string;
  priceChange: number;
  userCurrency: string;
  coinName: string;
  networkName: string;
  networkId: string;
  symbol: string;
  coinLogoUrl: string | null;
  changenow_legacy_ticker: string | null;
  changenow_ticker: string | null;
  changenow_network_id: string | null;
  balance_formatted: string;
  balance_currency: string;
  balance_symbol: string;
  balanceInFiat_formatted: string;
}

export interface WalletBalanceData {
  totalBalanceInFiat: number;
  totalBalanceInUsd: number;
  totalBalanceInFiat_formatted: string;
  totalBalanceInFiat_currency: string;
  totalBalanceInFiat_symbol: string;
  wallets: WalletBalance[];
}

export interface UserWalletBalanceResponse {
  data: WalletBalanceData[];
  message: string;
  status: number;
  success: boolean;
}